import {
  Autocomplete,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import * as React from 'react'

import { tsScreenCollection } from '../../../../Typescript/DB_Interface'
import { useHealthContext } from '../../../../Contexts/Modules/HealthModule/HealthModule'

function CriteriaDetailsField({
  addCollection,
  setAddCollection,
}: {
  addCollection: any
  setAddCollection: any
}) {
  const { lineQuery } = useHealthContext()
  const lineData = lineQuery.data ?? []
  switch (addCollection?.Criteria) {
    case '1': // Rack (Allow multiple racks to be selected + 'All racks' option)
      return (
        <FormControl
          required
          fullWidth
        >
          <InputLabel>Racks Sampled</InputLabel>
          <Select
            multiple
            label="Racks Sampled"
            name="CriteriaDetails"
            onChange={(e) => {
              setAddCollection((c: any) => {
                return {
                  ...c,
                  CriteriaDetails: e.target.value.join(', '),
                }
              })
            }}
            value={
              addCollection?.CriteriaDetails ?
                addCollection.CriteriaDetails.split(', ')
              : []
            }
          >
            {[
              'All racks',
              'Rack 1',
              'Rack 2',
              'Rack 3',
              'Rack 4',
              'Rack 5',
              'Rack 6',
              'Rack 7',
              'Rack 8',
              'Rack 9',
              'Rack 10',
              'Rack 11',
            ].map((item) => (
              <MenuItem
                value={item}
                key={item}
              >
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )
    case '2': // Container (Allow more than 1 line to be selected)
    case '4': // Line (Allow more than 1 line to be selected)
      return (
        <Autocomplete
          value={
            addCollection?.CriteriaDetails ?
              addCollection.CriteriaDetails.split(', ')
            : []
          }
          multiple
          onChange={(_, newValue) => {
            setAddCollection((c: any) => {
              return {
                ...c,
                CriteriaDetails: newValue.join(', '),
              }
            })
          }}
          options={
            lineData ? lineData.map((line) => line.CodeDescription) : ['']
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label={'Lines Sampled'}
            />
          )}
          fullWidth
        />
      )
    case '3': // Mouse (Only one line can be selected)
    case '6': // Rat (Only one line can be selected)
    case '7': // Zebrafish (Only one line can be selected)
      return (
        <Autocomplete
          value={addCollection?.CriteriaDetails ?? ''}
          onChange={(_, newValue) => {
            setAddCollection((c: any) => {
              return {
                ...c,
                CriteriaDetails: newValue,
              }
            })
          }}
          options={
            lineData ? lineData.map((line) => line.CodeDescription) : ['']
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label={'Line Sampled'}
            />
          )}
          fullWidth
        />
      )
    default: // Environment (Text field)
      return (
        <TextField
          required
          label="Item(s) sampled"
          fullWidth
          value={addCollection?.CriteriaDetails ?? ''}
          onChange={(e) =>
            setAddCollection(
              (col: { index: number; collection: tsScreenCollection }) => ({
                ...col,
                CriteriaDetails: e.target.value,
              }),
            )
          }
        />
      )
  }
}

export default CriteriaDetailsField
